import * as React from "react";
import MailchimpFormContainer from "./Mailing";
import NavBar from "./NavBar";
import Slogan from "./Slogan";
import Demo from "./Demo";
import Description from "./Description";

export default function HomePage() {
    return (
        <>
            <NavBar /> 
            <Slogan />
            <Demo />
            {/* <Description/> */}
            <MailchimpFormContainer/>
        </>
    );
}
